import React, { FunctionComponent, ReactNode } from "react";
import { HiOutlineRefresh } from "react-icons/hi";

interface UploadTileProps {
  icon: ReactNode;
  label: string;
  hint?: string;
  disabled?: boolean;
  loading?: boolean;
  onClick?: () => void;
}

/**
 * Clean dashed "tile" trigger shared by the File / Video upload question types. Renders a div so it
 * can also sit inside an antd `<Upload>` (which owns the click) — pass `onClick` only for the
 * non-Upload actions (e.g. Record video).
 */
const UploadTile: FunctionComponent<UploadTileProps> = ({ icon, label, hint, disabled, loading, onClick }) => {
  const interactive = !disabled && !loading;
  return (
    <div
      role="button"
      tabIndex={interactive ? 0 : -1}
      onClick={interactive ? onClick : undefined}
      className={[
        "inline-flex w-fit items-center gap-2 rounded-lg border border-dashed px-4 py-2 select-none",
        "transition-colors",
        interactive ? "border-neutral-5 hover:border-primary-6 hover:bg-primary-1 cursor-pointer" : "border-neutral-5 opacity-60 cursor-not-allowed"
      ].join(" ")}
    >
      <span className="flex items-center text-neutral-9">{loading ? <HiOutlineRefresh className="animate-spin text-base" /> : icon}</span>
      <span className="text-sm font-medium text-neutral-11 leading-none">{loading ? "Uploading…" : label}</span>
      {hint && !loading && <span className="text-xs text-neutral-8 leading-none">{hint}</span>}
    </div>
  );
};

export default UploadTile;
